import { validateEmail, validatePhone } from './contactValidation'
import { OrderItem } from '../types/Order'

interface CreateOrderValidationInputs {
  customerName: string
  customerEmail: string
  customerPhone: string
  deliveryTimeSlot?: string | undefined
  productsToAdd: OrderItem[]
  selectedDeliveryMethod?: { deliveryProviderType?: number } | null
  deliveryAddress?: string
  zipCode?: string
  city?: string
}

interface CreateOrderValidationResult {
  isValid: boolean
  errors: {
    name: boolean
    email: boolean
    phone: boolean
    deliveryTime: boolean
    products: boolean
    deliveryMethod: boolean
    homeDeliveryInfo: boolean
  }
}

export function validateOrder(inputs: CreateOrderValidationInputs): CreateOrderValidationResult {
  const nameOk = inputs.customerName.trim().length > 0
  const emailOk = validateEmail(inputs.customerEmail)
  const phoneOk = validatePhone(inputs.customerPhone)
  const deliveryTimeOk = !!inputs.deliveryTimeSlot
  const productsOk = Array.isArray(inputs.productsToAdd) && inputs.productsToAdd.length > 0
  const deliveryMethodOk = !!inputs.selectedDeliveryMethod

  const homeDeliveryInfoRequired = inputs.selectedDeliveryMethod?.deliveryProviderType === 1000
  const homeDeliveryInfoOk = !homeDeliveryInfoRequired || (
    (inputs.deliveryAddress || '').trim().length > 0 &&
    (inputs.zipCode || '').trim().length > 0 &&
    (inputs.city || '').trim().length > 0
  )

  const errors = {
    name: nameOk,
    email: emailOk,
    phone: phoneOk,
    deliveryTime: deliveryTimeOk,
    products: productsOk,
    deliveryMethod: deliveryMethodOk,
    homeDeliveryInfo: homeDeliveryInfoOk,
  }

  const isValid = Object.values(errors).every(Boolean)

  return { isValid, errors }
}